/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { ProviderEditDto, ProviderListDto } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { FileDto, ProductCategoryListDto, UserListDto } from './shared-models';

@Injectable()
export class ProviderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param filter (optional)
     * @param activeStatus (optional)
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getProviders(
        filter: string | undefined,
        activeStatus: boolean | undefined,
        id: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<ProviderListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviders?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (activeStatus === null) throw new Error("The parameter 'activeStatus' cannot be null.");
        else if (activeStatus !== undefined) url_ += 'ActiveStatus=' + encodeURIComponent('' + activeStatus) + '&';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviders(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviders(response: HttpResponseBase): Observable<ProviderListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderListDtoPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProviderCommissionTerms(): Observable<ProviderCommissionTermDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderCommissionTerms';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderCommissionTerms(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderCommissionTerms(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderCommissionTermDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderCommissionTermDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderCommissionTerms(response: HttpResponseBase): Observable<ProviderCommissionTermDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderCommissionTermDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderCommissionTermDto[]>([]);
    }

    /**
     * @return Success
     */
    getProviderCategories(): Observable<ProviderCategoryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderCategories';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderCategories(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderCategories(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderCategoryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderCategoryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderCategories(response: HttpResponseBase): Observable<ProviderCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderCategoryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderCategoryDto[]>([]);
    }

    /**
     * @param id (optional)
     * @param nameMatch (optional)
     * @return Success
     */
    getProviderNameMatchList(id: number | undefined, nameMatch: string[] | undefined): Observable<ProviderNameMatchDto> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderNameMatchList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (nameMatch === null) throw new Error("The parameter 'nameMatch' cannot be null.");
        else if (nameMatch !== undefined)
            nameMatch &&
                nameMatch.forEach((item) => {
                    url_ += 'NameMatch=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderNameMatchList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderNameMatchList(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderNameMatchDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderNameMatchDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderNameMatchList(response: HttpResponseBase): Observable<ProviderNameMatchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderNameMatchDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderNameMatchDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateProviderNameMatchList(body: ProviderNameMatchInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Provider/UpdateProviderNameMatchList';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateProviderNameMatchList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateProviderNameMatchList(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateProviderNameMatchList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    providerListForProducts(body: number[] | undefined): Observable<ProviderListofProductOutput> {
        let url_ = this.baseUrl + '/api/services/app/Provider/ProviderListForProducts';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProviderListForProducts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProviderListForProducts(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderListofProductOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderListofProductOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProviderListForProducts(response: HttpResponseBase): Observable<ProviderListofProductOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderListofProductOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderListofProductOutput>(<any>null);
    }

    /**
     * @param input (optional)
     * @param isCommission (optional)
     * @return Success
     */
    getProviderList(input: string | undefined, isCommission: boolean | undefined): Observable<ProviderListForQuoteDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        if (isCommission === null) throw new Error("The parameter 'isCommission' cannot be null.");
        else if (isCommission !== undefined) url_ += 'isCommission=' + encodeURIComponent('' + isCommission) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderList(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderListForQuoteDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderListForQuoteDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderList(response: HttpResponseBase): Observable<ProviderListForQuoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderListForQuoteDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderListForQuoteDto[]>([]);
    }

    /**
     * @param input (optional)
     * @param providerId (optional)
     * @return Success
     */
    getProvidersAndUsersList(input: string | undefined, providerId: number | undefined): Observable<ProvidersAndUsersListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProvidersAndUsersList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProvidersAndUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProvidersAndUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<ProvidersAndUsersListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProvidersAndUsersListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProvidersAndUsersList(response: HttpResponseBase): Observable<ProvidersAndUsersListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProvidersAndUsersListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProvidersAndUsersListDto[]>([]);
    }

    /**
     * @return Success
     */
    getProvidersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProvidersToExcel';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProvidersToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProvidersToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProvidersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProviderForEdit(id: number | undefined): Observable<ProviderEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderForEdit(response: HttpResponseBase): Observable<ProviderEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProvider(body: ProviderEditDto | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Provider/CreateOrUpdateProvider';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProvider(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProvider(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProvider(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProvider(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Provider/DeleteProvider?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProvider(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProvider(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProvider(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    assignOrUnassignCarrier(body: AssignOrUnassignCarrierInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Provider/AssignOrUnassignCarrier';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAssignOrUnassignCarrier(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAssignOrUnassignCarrier(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAssignOrUnassignCarrier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getFilteredProductList(id: number | undefined): Observable<AssignedCarrierDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetFilteredProductList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetFilteredProductList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetFilteredProductList(<any>response_);
                        } catch (e) {
                            return <Observable<AssignedCarrierDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AssignedCarrierDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetFilteredProductList(response: HttpResponseBase): Observable<AssignedCarrierDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AssignedCarrierDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AssignedCarrierDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCompMatrix(id: number | undefined): Observable<CompMatrixDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetCompMatrix?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCompMatrix(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCompMatrix(<any>response_);
                        } catch (e) {
                            return <Observable<CompMatrixDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CompMatrixDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCompMatrix(response: HttpResponseBase): Observable<CompMatrixDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CompMatrixDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CompMatrixDto[]>([]);
    }

    /**
     * @param providerId (optional)
     * @return Success
     */
    getProviderUserList(providerId: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderUserList?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getProvidersForDropdown(): Observable<ProviderDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProvidersForDropdown';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProvidersForDropdown(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProvidersForDropdown(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProvidersForDropdown(response: HttpResponseBase): Observable<ProviderDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderDropdownDto[]>([]);
    }

    /**
     * @return Success
     */
    getProviderManagers(): Observable<ProviderManagerListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderManagers';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderManagers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderManagers(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderManagerListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderManagerListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderManagers(response: HttpResponseBase): Observable<ProviderManagerListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderManagerListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderManagerListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProviderManager(id: number | undefined): Observable<ProviderManagerListDto> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetProviderManager?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderManager(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderManager(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderManagerListDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderManagerListDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderManager(response: HttpResponseBase): Observable<ProviderManagerListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderManagerListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderManagerListDto>(<any>null);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    createProviderManager(userId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Provider/CreateProviderManager?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateProviderManager(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateProviderManager(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateProviderManager(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProviderManager(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Provider/DeleteProviderManager?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProviderManager(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProviderManager(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProviderManager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateSalesCode(body: SaleCodeDto | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Provider/CreateOrUpdateSalesCode';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateSalesCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateSalesCode(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateSalesCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteSalesCode(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Provider/DeleteSalesCode?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteSalesCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteSalesCode(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteSalesCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param providerId (optional)
     * @return Success
     */
    getSalesCodes(providerId: number | undefined): Observable<SaleCodeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetSalesCodes?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesCodes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesCodes(<any>response_);
                        } catch (e) {
                            return <Observable<SaleCodeDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SaleCodeDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesCodes(response: HttpResponseBase): Observable<SaleCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SaleCodeDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SaleCodeDto[]>([]);
    }

    /**
     * @param providerId (optional)
     * @return Success
     */
    getActiveSalesCode(providerId: number | undefined): Observable<SaleCodeDto> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetActiveSalesCode?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActiveSalesCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActiveSalesCode(<any>response_);
                        } catch (e) {
                            return <Observable<SaleCodeDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SaleCodeDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActiveSalesCode(response: HttpResponseBase): Observable<SaleCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SaleCodeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SaleCodeDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getSalesCode(id: number | undefined): Observable<SaleCodeDto> {
        let url_ = this.baseUrl + '/api/services/app/Provider/GetSalesCode?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesCode(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesCode(<any>response_);
                        } catch (e) {
                            return <Observable<SaleCodeDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SaleCodeDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesCode(response: HttpResponseBase): Observable<SaleCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SaleCodeDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SaleCodeDto>(<any>null);
    }
}

@Injectable()
export class ProviderOrderStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param providerId (optional)
     * @return Success
     */
    getProviderOrderStatusMappings(providerId: number | undefined): Observable<ProviderOrderStatusMapDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ProviderOrderStatus/GetProviderOrderStatusMappings?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderOrderStatusMappings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderOrderStatusMappings(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderOrderStatusMapDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderOrderStatusMapDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderOrderStatusMappings(response: HttpResponseBase): Observable<ProviderOrderStatusMapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderOrderStatusMapDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderOrderStatusMapDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    saveProviderOrderStatusMappings(body: ProviderOrderStatusMapEditInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/ProviderOrderStatus/SaveProviderOrderStatusMappings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSaveProviderOrderStatusMappings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSaveProviderOrderStatusMappings(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSaveProviderOrderStatusMappings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProviderPortalAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param providerId (optional)
     * @return Success
     */
    getProviderPortalAdmins(providerId: number | undefined): Observable<ProviderPortalAdminDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ProviderPortalAdmin/GetProviderPortalAdmins?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderPortalAdmins(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderPortalAdmins(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderPortalAdminDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderPortalAdminDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderPortalAdmins(response: HttpResponseBase): Observable<ProviderPortalAdminDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderPortalAdminDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderPortalAdminDto[]>([]);
    }

    /**
     * @param portalAdminId (optional)
     * @return Success
     */
    getProviderPortalAdmin(portalAdminId: number | undefined): Observable<ProviderPortalAdminDto> {
        let url_ = this.baseUrl + '/api/services/app/ProviderPortalAdmin/GetProviderPortalAdmin?';
        if (portalAdminId === null) throw new Error("The parameter 'portalAdminId' cannot be null.");
        else if (portalAdminId !== undefined) url_ += 'portalAdminId=' + encodeURIComponent('' + portalAdminId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderPortalAdmin(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderPortalAdmin(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderPortalAdminDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderPortalAdminDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderPortalAdmin(response: HttpResponseBase): Observable<ProviderPortalAdminDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderPortalAdminDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderPortalAdminDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProviderPortalAdmin(body: ProviderPortalAdminEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/ProviderPortalAdmin/CreateOrUpdateProviderPortalAdmin';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProviderPortalAdmin(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProviderPortalAdmin(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProviderPortalAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param portalAdminId (optional)
     * @return Success
     */
    deleteProviderPortalAdmin(portalAdminId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/ProviderPortalAdmin/DeleteProviderPortalAdmin?';
        if (portalAdminId === null) throw new Error("The parameter 'portalAdminId' cannot be null.");
        else if (portalAdminId !== undefined) url_ += 'portalAdminId=' + encodeURIComponent('' + portalAdminId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProviderPortalAdmin(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProviderPortalAdmin(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProviderPortalAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProviderSpotlightServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     * @deprecated
     */
    getCtaProvidersForDashboard(): Observable<CtaProviderDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/GetCtaProvidersForDashboard';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCtaProvidersForDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCtaProvidersForDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<CtaProviderDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CtaProviderDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCtaProvidersForDashboard(response: HttpResponseBase): Observable<CtaProviderDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CtaProviderDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CtaProviderDashboardOutput[]>([]);
    }

    /**
     * @param filter (optional)
     * @param selectedStatuses (optional)
     * @return Success
     * @deprecated
     */
    getProviderSpotlightList(filter: string | undefined, selectedStatuses: string[] | undefined): Observable<ProviderSpotlightListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/GetProviderSpotlightList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (selectedStatuses === null) throw new Error("The parameter 'selectedStatuses' cannot be null.");
        else if (selectedStatuses !== undefined)
            selectedStatuses &&
                selectedStatuses.forEach((item) => {
                    url_ += 'SelectedStatuses=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderSpotlightList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderSpotlightList(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderSpotlightListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderSpotlightListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderSpotlightList(response: HttpResponseBase): Observable<ProviderSpotlightListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderSpotlightListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderSpotlightListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getProviderSpotlightForEdit(id: number | undefined): Observable<ProviderSpotlightEditDto> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/GetProviderSpotlightForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderSpotlightForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderSpotlightForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderSpotlightEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderSpotlightEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderSpotlightForEdit(response: HttpResponseBase): Observable<ProviderSpotlightEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderSpotlightEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderSpotlightEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param partnerId (optional)
     * @return Success
     * @deprecated
     */
    getProviderSpotlight(id: number | undefined, partnerId: number | undefined): Observable<ProviderSpotlightOutput> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/GetProviderSpotlight?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderSpotlight(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderSpotlight(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderSpotlightOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderSpotlightOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderSpotlight(response: HttpResponseBase): Observable<ProviderSpotlightOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderSpotlightOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderSpotlightOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateProviderSpotlight(body: CreateOrUpdateProviderSpotlightInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/CreateOrUpdateProviderSpotlight';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProviderSpotlight(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProviderSpotlight(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProviderSpotlight(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deleteProviderSpotlight(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/DeleteProviderSpotlight?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProviderSpotlight(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProviderSpotlight(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProviderSpotlight(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     * @deprecated
     */
    getCtaTypeList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/GetCtaTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCtaTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCtaTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCtaTypeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getStatusList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/GetStatusList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getProviderSpotlightImage(): Observable<GetProviderSpotlightDashboardImage> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/GetProviderSpotlightImage';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderSpotlightImage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderSpotlightImage(<any>response_);
                        } catch (e) {
                            return <Observable<GetProviderSpotlightDashboardImage>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProviderSpotlightDashboardImage>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderSpotlightImage(response: HttpResponseBase): Observable<GetProviderSpotlightDashboardImage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProviderSpotlightDashboardImage.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProviderSpotlightDashboardImage>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    updateProviderSpotlightImage(body: GetProviderSpotlightDashboardImage | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/ProviderSpotlight/UpdateProviderSpotlightImage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateProviderSpotlightImage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateProviderSpotlightImage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateProviderSpotlightImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

export class AssignOrUnassignCarrierInput implements IAssignOrUnassignCarrierInput {
    providerId: number;
    productId: number;
    isAssigned: boolean;

    constructor(data?: IAssignOrUnassignCarrierInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.productId = _data['productId'];
            this.isAssigned = _data['isAssigned'];
        }
    }

    static fromJS(data: any): AssignOrUnassignCarrierInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignOrUnassignCarrierInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['productId'] = this.productId;
        data['isAssigned'] = this.isAssigned;
        return data;
    }

    clone(): AssignOrUnassignCarrierInput {
        const json = this.toJSON();
        let result = new AssignOrUnassignCarrierInput();
        result.init(json);
        return result;
    }
}

export interface IAssignOrUnassignCarrierInput {
    providerId: number;
    productId: number;
    isAssigned: boolean;
}

export class AssignedCarrierDto implements IAssignedCarrierDto {
    id: number | undefined;
    productCategory: ProductCategoryListDto;
    name: string;
    isAssigned: boolean;
    providerProductId?: number;
    grossPercentRateOverride?: number | null;

    constructor(data?: IAssignedCarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.productCategory = _data['productCategory'] ? ProductCategoryListDto.fromJS(_data['productCategory']) : <any>undefined;
            this.name = _data['name'];
            this.isAssigned = _data['isAssigned'];
            this.providerProductId = _data['providerProductId'];
            this.grossPercentRateOverride = _data['grossPercentRateOverride'];
        }
    }

    static fromJS(data: any): AssignedCarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedCarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['productCategory'] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['isAssigned'] = this.isAssigned;
        data['providerProductId'] = this.providerProductId;
        data['grossPercentRateOverride'] = this.grossPercentRateOverride;
        return data;
    }

    clone(): AssignedCarrierDto {
        const json = this.toJSON();
        let result = new AssignedCarrierDto();
        result.init(json);
        return result;
    }
}

export interface IAssignedCarrierDto {
    id: number | undefined;
    productCategory: ProductCategoryListDto;
    name: string;
    isAssigned: boolean;
    providerProductId?: number;
    grossPercentRateOverride?: number | null;
}

export enum CTAType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CompMatrixDto implements ICompMatrixDto {
    id: number;
    providerId: number;
    providerName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    rate: number;
    commissionEstimate: number;
    providerCommissionTermName: string | undefined;
    productList: string[] | undefined;
    compensationNotes: string | undefined;

    constructor(data?: ICompMatrixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.rate = _data['rate'];
            this.commissionEstimate = _data['commissionEstimate'];
            this.providerCommissionTermName = _data['providerCommissionTermName'];
            if (Array.isArray(_data['productList'])) {
                this.productList = [] as any;
                for (let item of _data['productList']) this.productList.push(item);
            }
            this.compensationNotes = _data['compensationNotes'];
        }
    }

    static fromJS(data: any): CompMatrixDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompMatrixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['rate'] = this.rate;
        data['commissionEstimate'] = this.commissionEstimate;
        data['providerCommissionTermName'] = this.providerCommissionTermName;
        if (Array.isArray(this.productList)) {
            data['productList'] = [];
            for (let item of this.productList) data['productList'].push(item);
        }
        data['compensationNotes'] = this.compensationNotes;
        return data;
    }

    clone(): CompMatrixDto {
        const json = this.toJSON();
        let result = new CompMatrixDto();
        result.init(json);
        return result;
    }
}

export interface ICompMatrixDto {
    id: number;
    providerId: number;
    providerName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    rate: number;
    commissionEstimate: number;
    providerCommissionTermName: string | undefined;
    productList: string[] | undefined;
    compensationNotes: string | undefined;
}

export class CreateOrUpdateProviderSpotlightInput implements ICreateOrUpdateProviderSpotlightInput {
    providerSpotlight: ProviderSpotlightEditDto;

    constructor(data?: ICreateOrUpdateProviderSpotlightInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.providerSpotlight = new ProviderSpotlightEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerSpotlight = _data['providerSpotlight']
                ? ProviderSpotlightEditDto.fromJS(_data['providerSpotlight'])
                : new ProviderSpotlightEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProviderSpotlightInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProviderSpotlightInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerSpotlight'] = this.providerSpotlight ? this.providerSpotlight.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProviderSpotlightInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProviderSpotlightInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProviderSpotlightInput {
    providerSpotlight: ProviderSpotlightEditDto;
}

export class CtaProviderDashboardOutput implements ICtaProviderDashboardOutput {
    providerSpotlightId: number;
    name: string | undefined;
    providerBannerSourceUrl: string | undefined;
    ctaType: CTAType;

    constructor(data?: ICtaProviderDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerSpotlightId = _data['providerSpotlightId'];
            this.name = _data['name'];
            this.providerBannerSourceUrl = _data['providerBannerSourceUrl'];
            this.ctaType = _data['ctaType'];
        }
    }

    static fromJS(data: any): CtaProviderDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CtaProviderDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerSpotlightId'] = this.providerSpotlightId;
        data['name'] = this.name;
        data['providerBannerSourceUrl'] = this.providerBannerSourceUrl;
        data['ctaType'] = this.ctaType;
        return data;
    }

    clone(): CtaProviderDashboardOutput {
        const json = this.toJSON();
        let result = new CtaProviderDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ICtaProviderDashboardOutput {
    providerSpotlightId: number;
    name: string | undefined;
    providerBannerSourceUrl: string | undefined;
    ctaType: CTAType;
}

export class GetProviderSpotlightDashboardImage implements IGetProviderSpotlightDashboardImage {
    imageUrl: string | undefined;

    constructor(data?: IGetProviderSpotlightDashboardImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data['imageUrl'];
        }
    }

    static fromJS(data: any): GetProviderSpotlightDashboardImage {
        data = typeof data === 'object' ? data : {};
        let result = new GetProviderSpotlightDashboardImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['imageUrl'] = this.imageUrl;
        return data;
    }

    clone(): GetProviderSpotlightDashboardImage {
        const json = this.toJSON();
        let result = new GetProviderSpotlightDashboardImage();
        result.init(json);
        return result;
    }
}

export interface IGetProviderSpotlightDashboardImage {
    imageUrl: string | undefined;
}

export class ProviderCategoryDto implements IProviderCategoryDto {
    id: number;
    name: string | undefined;
    isDefault: boolean;

    constructor(data?: IProviderCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.isDefault = _data['isDefault'];
        }
    }

    static fromJS(data: any): ProviderCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['isDefault'] = this.isDefault;
        return data;
    }

    clone(): ProviderCategoryDto {
        const json = this.toJSON();
        let result = new ProviderCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IProviderCategoryDto {
    id: number;
    name: string | undefined;
    isDefault: boolean;
}
export class ProviderCommissionTermDto implements IProviderCommissionTermDto {
    name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderCommissionTermDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderCommissionTermDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderCommissionTermDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderCommissionTermDto {
        const json = this.toJSON();
        let result = new ProviderCommissionTermDto();
        result.init(json);
        return result;
    }
}

export interface IProviderCommissionTermDto {
    name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderDropdownDto implements IProviderDropdownDto {
    id: number;
    name: string | undefined;

    constructor(data?: IProviderDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): ProviderDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): ProviderDropdownDto {
        const json = this.toJSON();
        let result = new ProviderDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IProviderDropdownDto {
    id: number;
    name: string | undefined;
}

export class ProviderListDtoPagedResultDto implements IProviderListDtoPagedResultDto {
    totalCount: number;
    items: ProviderListDto[] | undefined;

    constructor(data?: IProviderListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ProviderListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProviderListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProviderListDtoPagedResultDto {
    totalCount: number;
    items: ProviderListDto[] | undefined;
}

export class ProviderListForProductDto implements IProviderListForProductDto {
    productName: string | undefined;
    productId: number;
    providerList: ProviderListForQuoteDto[] | undefined;

    constructor(data?: IProviderListForProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data['productName'];
            this.productId = _data['productId'];
            if (Array.isArray(_data['providerList'])) {
                this.providerList = [] as any;
                for (let item of _data['providerList']) this.providerList.push(ProviderListForQuoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderListForProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderListForProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productName'] = this.productName;
        data['productId'] = this.productId;
        if (Array.isArray(this.providerList)) {
            data['providerList'] = [];
            for (let item of this.providerList) data['providerList'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderListForProductDto {
        const json = this.toJSON();
        let result = new ProviderListForProductDto();
        result.init(json);
        return result;
    }
}

export interface IProviderListForProductDto {
    productName: string | undefined;
    productId: number;
    providerList: ProviderListForQuoteDto[] | undefined;
}

export class ProviderListForQuoteDto implements IProviderListForQuoteDto {
    name: string | undefined;
    imageSourceUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderListForQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.imageSourceUrl = _data['imageSourceUrl'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderListForQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderListForQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['imageSourceUrl'] = this.imageSourceUrl;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderListForQuoteDto {
        const json = this.toJSON();
        let result = new ProviderListForQuoteDto();
        result.init(json);
        return result;
    }
}

export interface IProviderListForQuoteDto {
    name: string | undefined;
    imageSourceUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderListofProductOutput implements IProviderListofProductOutput {
    providerListProduct: ProviderListForProductDto[] | undefined;

    constructor(data?: IProviderListofProductOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['providerListProduct'])) {
                this.providerListProduct = [] as any;
                for (let item of _data['providerListProduct']) this.providerListProduct.push(ProviderListForProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderListofProductOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderListofProductOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providerListProduct)) {
            data['providerListProduct'] = [];
            for (let item of this.providerListProduct) data['providerListProduct'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderListofProductOutput {
        const json = this.toJSON();
        let result = new ProviderListofProductOutput();
        result.init(json);
        return result;
    }
}

export interface IProviderListofProductOutput {
    providerListProduct: ProviderListForProductDto[] | undefined;
}

export class ProviderManagerListDto implements IProviderManagerListDto {
    id: number;
    userId: number;
    user: UserListDto;

    constructor(data?: IProviderManagerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.userId = _data['userId'];
            this.user = _data['user'] ? UserListDto.fromJS(_data['user']) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderManagerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderManagerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProviderManagerListDto {
        const json = this.toJSON();
        let result = new ProviderManagerListDto();
        result.init(json);
        return result;
    }
}

export interface IProviderManagerListDto {
    id: number;
    userId: number;
    user: UserListDto;
}

export class ProviderNameMatchDto implements IProviderNameMatchDto {
    id: number;
    nameMatchList: string[] | undefined;

    constructor(data?: IProviderNameMatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            if (Array.isArray(_data['nameMatchList'])) {
                this.nameMatchList = [] as any;
                for (let item of _data['nameMatchList']) this.nameMatchList.push(item);
            }
        }
    }

    static fromJS(data: any): ProviderNameMatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderNameMatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        if (Array.isArray(this.nameMatchList)) {
            data['nameMatchList'] = [];
            for (let item of this.nameMatchList) data['nameMatchList'].push(item);
        }
        return data;
    }

    clone(): ProviderNameMatchDto {
        const json = this.toJSON();
        let result = new ProviderNameMatchDto();
        result.init(json);
        return result;
    }
}

export interface IProviderNameMatchDto {
    id: number;
    nameMatchList: string[] | undefined;
}

export class ProviderNameMatchInput implements IProviderNameMatchInput {
    id: number;
    nameMatch: string[] | undefined;

    constructor(data?: IProviderNameMatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            if (Array.isArray(_data['nameMatch'])) {
                this.nameMatch = [] as any;
                for (let item of _data['nameMatch']) this.nameMatch.push(item);
            }
        }
    }

    static fromJS(data: any): ProviderNameMatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderNameMatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        if (Array.isArray(this.nameMatch)) {
            data['nameMatch'] = [];
            for (let item of this.nameMatch) data['nameMatch'].push(item);
        }
        return data;
    }

    clone(): ProviderNameMatchInput {
        const json = this.toJSON();
        let result = new ProviderNameMatchInput();
        result.init(json);
        return result;
    }
}

export interface IProviderNameMatchInput {
    id: number;
    nameMatch: string[] | undefined;
}

export class ProviderOrderStatusMapDto implements IProviderOrderStatusMapDto {
    id: number;
    tenantId: number | undefined;
    providerId: number;
    providerName: string | undefined;
    orderStatusId: number;
    orderStatusName: string | undefined;
    providerOrderStatus: string | undefined;

    constructor(data?: IProviderOrderStatusMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.orderStatusId = _data['orderStatusId'];
            this.orderStatusName = _data['orderStatusName'];
            this.providerOrderStatus = _data['providerOrderStatus'];
        }
    }

    static fromJS(data: any): ProviderOrderStatusMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderOrderStatusMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['orderStatusId'] = this.orderStatusId;
        data['orderStatusName'] = this.orderStatusName;
        data['providerOrderStatus'] = this.providerOrderStatus;
        return data;
    }

    clone(): ProviderOrderStatusMapDto {
        const json = this.toJSON();
        let result = new ProviderOrderStatusMapDto();
        result.init(json);
        return result;
    }
}

export interface IProviderOrderStatusMapDto {
    id: number;
    tenantId: number | undefined;
    providerId: number;
    providerName: string | undefined;
    orderStatusId: number;
    orderStatusName: string | undefined;
    providerOrderStatus: string | undefined;
}

export class ProviderOrderStatusMapEditDto implements IProviderOrderStatusMapEditDto {
    providerOrderStatusMapId: number | undefined;
    orderStatusId: number;
    providerOrderStatus: string | undefined;

    constructor(data?: IProviderOrderStatusMapEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerOrderStatusMapId = _data['providerOrderStatusMapId'];
            this.orderStatusId = _data['orderStatusId'];
            this.providerOrderStatus = _data['providerOrderStatus'];
        }
    }

    static fromJS(data: any): ProviderOrderStatusMapEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderOrderStatusMapEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerOrderStatusMapId'] = this.providerOrderStatusMapId;
        data['orderStatusId'] = this.orderStatusId;
        data['providerOrderStatus'] = this.providerOrderStatus;
        return data;
    }

    clone(): ProviderOrderStatusMapEditDto {
        const json = this.toJSON();
        let result = new ProviderOrderStatusMapEditDto();
        result.init(json);
        return result;
    }
}

export interface IProviderOrderStatusMapEditDto {
    providerOrderStatusMapId: number | undefined;
    orderStatusId: number;
    providerOrderStatus: string | undefined;
}

export class ProviderOrderStatusMapEditInput implements IProviderOrderStatusMapEditInput {
    providerId: number;
    mappings: ProviderOrderStatusMapEditDto[] | undefined;
    readonly mappingIds: number[] | undefined;

    constructor(data?: IProviderOrderStatusMapEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            if (Array.isArray(_data['mappings'])) {
                this.mappings = [] as any;
                for (let item of _data['mappings']) this.mappings.push(ProviderOrderStatusMapEditDto.fromJS(item));
            }
            if (Array.isArray(_data['mappingIds'])) {
                (<any>this).mappingIds = [] as any;
                for (let item of _data['mappingIds']) (<any>this).mappingIds.push(item);
            }
        }
    }

    static fromJS(data: any): ProviderOrderStatusMapEditInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderOrderStatusMapEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        if (Array.isArray(this.mappings)) {
            data['mappings'] = [];
            for (let item of this.mappings) data['mappings'].push(item.toJSON());
        }
        if (Array.isArray(this.mappingIds)) {
            data['mappingIds'] = [];
            for (let item of this.mappingIds) data['mappingIds'].push(item);
        }
        return data;
    }

    clone(): ProviderOrderStatusMapEditInput {
        const json = this.toJSON();
        let result = new ProviderOrderStatusMapEditInput();
        result.init(json);
        return result;
    }
}

export interface IProviderOrderStatusMapEditInput {
    providerId: number;
    mappings: ProviderOrderStatusMapEditDto[] | undefined;
    mappingIds: number[] | undefined;
}

export class ProviderPortalAdminDto implements IProviderPortalAdminDto {
    providerId: number;
    contactName: string | undefined;
    title: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    note: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderPortalAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.contactName = _data['contactName'];
            this.title = _data['title'];
            this.phone = _data['phone'];
            this.email = _data['email'];
            this.note = _data['note'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderPortalAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPortalAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['contactName'] = this.contactName;
        data['title'] = this.title;
        data['phone'] = this.phone;
        data['email'] = this.email;
        data['note'] = this.note;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderPortalAdminDto {
        const json = this.toJSON();
        let result = new ProviderPortalAdminDto();
        result.init(json);
        return result;
    }
}

export interface IProviderPortalAdminDto {
    providerId: number;
    contactName: string | undefined;
    title: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    note: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderPortalAdminEditDto implements IProviderPortalAdminEditDto {
    providerId: number;
    contactName: string | undefined;
    title: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    note: string | undefined;
    id: number | undefined;

    constructor(data?: IProviderPortalAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.contactName = _data['contactName'];
            this.title = _data['title'];
            this.phone = _data['phone'];
            this.email = _data['email'];
            this.note = _data['note'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderPortalAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPortalAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['contactName'] = this.contactName;
        data['title'] = this.title;
        data['phone'] = this.phone;
        data['email'] = this.email;
        data['note'] = this.note;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderPortalAdminEditDto {
        const json = this.toJSON();
        let result = new ProviderPortalAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface IProviderPortalAdminEditDto {
    providerId: number;
    contactName: string | undefined;
    title: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    note: string | undefined;
    id: number | undefined;
}

export class ProviderSpotlightCategoryOutput implements IProviderSpotlightCategoryOutput {
    name: string | undefined;
    cssClass: string | undefined;

    constructor(data?: IProviderSpotlightCategoryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.cssClass = _data['cssClass'];
        }
    }

    static fromJS(data: any): ProviderSpotlightCategoryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpotlightCategoryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['cssClass'] = this.cssClass;
        return data;
    }

    clone(): ProviderSpotlightCategoryOutput {
        const json = this.toJSON();
        let result = new ProviderSpotlightCategoryOutput();
        result.init(json);
        return result;
    }
}

export interface IProviderSpotlightCategoryOutput {
    name: string | undefined;
    cssClass: string | undefined;
}

export class ProviderSpotlightContactOutput implements IProviderSpotlightContactOutput {
    fullName: string | undefined;
    title: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    contactImageUrl: string | undefined;

    constructor(data?: IProviderSpotlightContactOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data['fullName'];
            this.title = _data['title'];
            this.email = _data['email'];
            this.phone = _data['phone'];
            this.contactImageUrl = _data['contactImageUrl'];
        }
    }

    static fromJS(data: any): ProviderSpotlightContactOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpotlightContactOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fullName'] = this.fullName;
        data['title'] = this.title;
        data['email'] = this.email;
        data['phone'] = this.phone;
        data['contactImageUrl'] = this.contactImageUrl;
        return data;
    }

    clone(): ProviderSpotlightContactOutput {
        const json = this.toJSON();
        let result = new ProviderSpotlightContactOutput();
        result.init(json);
        return result;
    }
}

export interface IProviderSpotlightContactOutput {
    fullName: string | undefined;
    title: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    contactImageUrl: string | undefined;
}

export class ProviderSpotlightEditDto implements IProviderSpotlightEditDto {
    providerId: number;
    name: string | undefined;
    description: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    videoLink: string | undefined;
    spotlightSourceUrl: string | undefined;
    ctaType: CTAType;
    status: ProviderSpotlightStatus;
    contactIds: number[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderSpotlightEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.name = _data['name'];
            this.description = _data['description'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.videoLink = _data['videoLink'];
            this.spotlightSourceUrl = _data['spotlightSourceUrl'];
            this.ctaType = _data['ctaType'];
            this.status = _data['status'];
            if (Array.isArray(_data['contactIds'])) {
                this.contactIds = [] as any;
                for (let item of _data['contactIds']) this.contactIds.push(item);
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderSpotlightEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpotlightEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['name'] = this.name;
        data['description'] = this.description;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['videoLink'] = this.videoLink;
        data['spotlightSourceUrl'] = this.spotlightSourceUrl;
        data['ctaType'] = this.ctaType;
        data['status'] = this.status;
        if (Array.isArray(this.contactIds)) {
            data['contactIds'] = [];
            for (let item of this.contactIds) data['contactIds'].push(item);
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderSpotlightEditDto {
        const json = this.toJSON();
        let result = new ProviderSpotlightEditDto();
        result.init(json);
        return result;
    }
}

export interface IProviderSpotlightEditDto {
    providerId: number;
    name: string | undefined;
    description: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    videoLink: string | undefined;
    spotlightSourceUrl: string | undefined;
    ctaType: CTAType;
    status: ProviderSpotlightStatus;
    contactIds: number[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderSpotlightEventOutput implements IProviderSpotlightEventOutput {
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    location: string | undefined;
    address: string | undefined;
    eventResourceUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderSpotlightEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.location = _data['location'];
            this.address = _data['address'];
            this.eventResourceUrl = _data['eventResourceUrl'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderSpotlightEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpotlightEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['location'] = this.location;
        data['address'] = this.address;
        data['eventResourceUrl'] = this.eventResourceUrl;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderSpotlightEventOutput {
        const json = this.toJSON();
        let result = new ProviderSpotlightEventOutput();
        result.init(json);
        return result;
    }
}

export interface IProviderSpotlightEventOutput {
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    location: string | undefined;
    address: string | undefined;
    eventResourceUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderSpotlightListDto implements IProviderSpotlightListDto {
    id: number;
    providerId: number;
    providerName: string | undefined;
    name: string | undefined;
    description: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    videoLink: string | undefined;
    ctaType: string | undefined;
    status: string | undefined;

    constructor(data?: IProviderSpotlightListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.name = _data['name'];
            this.description = _data['description'];
            this.startDate = _data['startDate'];
            this.endDate = _data['endDate'];
            this.videoLink = _data['videoLink'];
            this.ctaType = _data['ctaType'];
            this.status = _data['status'];
        }
    }

    static fromJS(data: any): ProviderSpotlightListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpotlightListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['name'] = this.name;
        data['description'] = this.description;
        data['startDate'] = this.startDate;
        data['endDate'] = this.endDate;
        data['videoLink'] = this.videoLink;
        data['ctaType'] = this.ctaType;
        data['status'] = this.status;
        return data;
    }

    clone(): ProviderSpotlightListDto {
        const json = this.toJSON();
        let result = new ProviderSpotlightListDto();
        result.init(json);
        return result;
    }
}

export interface IProviderSpotlightListDto {
    id: number;
    providerId: number;
    providerName: string | undefined;
    name: string | undefined;
    description: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    videoLink: string | undefined;
    ctaType: string | undefined;
    status: string | undefined;
}

export class ProviderSpotlightOutput implements IProviderSpotlightOutput {
    id: number;
    providerId: number;
    providerName: string | undefined;
    description: string | undefined;
    videoLinkUrl: string | undefined;
    providerImageSourceUrl: string | undefined;
    productCategories: ProviderSpotlightCategoryOutput[] | undefined;
    providerMatrix: number;
    channelManagers: ProviderSpotlightContactOutput[] | undefined;
    upcomingEvents: ProviderSpotlightEventOutput[] | undefined;
    providerSpotlightIds: number[] | undefined;

    constructor(data?: IProviderSpotlightOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.description = _data['description'];
            this.videoLinkUrl = _data['videoLinkUrl'];
            this.providerImageSourceUrl = _data['providerImageSourceUrl'];
            if (Array.isArray(_data['productCategories'])) {
                this.productCategories = [] as any;
                for (let item of _data['productCategories']) this.productCategories.push(ProviderSpotlightCategoryOutput.fromJS(item));
            }
            this.providerMatrix = _data['providerMatrix'];
            if (Array.isArray(_data['channelManagers'])) {
                this.channelManagers = [] as any;
                for (let item of _data['channelManagers']) this.channelManagers.push(ProviderSpotlightContactOutput.fromJS(item));
            }
            if (Array.isArray(_data['upcomingEvents'])) {
                this.upcomingEvents = [] as any;
                for (let item of _data['upcomingEvents']) this.upcomingEvents.push(ProviderSpotlightEventOutput.fromJS(item));
            }
            if (Array.isArray(_data['providerSpotlightIds'])) {
                this.providerSpotlightIds = [] as any;
                for (let item of _data['providerSpotlightIds']) this.providerSpotlightIds.push(item);
            }
        }
    }

    static fromJS(data: any): ProviderSpotlightOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpotlightOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['description'] = this.description;
        data['videoLinkUrl'] = this.videoLinkUrl;
        data['providerImageSourceUrl'] = this.providerImageSourceUrl;
        if (Array.isArray(this.productCategories)) {
            data['productCategories'] = [];
            for (let item of this.productCategories) data['productCategories'].push(item.toJSON());
        }
        data['providerMatrix'] = this.providerMatrix;
        if (Array.isArray(this.channelManagers)) {
            data['channelManagers'] = [];
            for (let item of this.channelManagers) data['channelManagers'].push(item.toJSON());
        }
        if (Array.isArray(this.upcomingEvents)) {
            data['upcomingEvents'] = [];
            for (let item of this.upcomingEvents) data['upcomingEvents'].push(item.toJSON());
        }
        if (Array.isArray(this.providerSpotlightIds)) {
            data['providerSpotlightIds'] = [];
            for (let item of this.providerSpotlightIds) data['providerSpotlightIds'].push(item);
        }
        return data;
    }

    clone(): ProviderSpotlightOutput {
        const json = this.toJSON();
        let result = new ProviderSpotlightOutput();
        result.init(json);
        return result;
    }
}

export interface IProviderSpotlightOutput {
    id: number;
    providerId: number;
    providerName: string | undefined;
    description: string | undefined;
    videoLinkUrl: string | undefined;
    providerImageSourceUrl: string | undefined;
    productCategories: ProviderSpotlightCategoryOutput[] | undefined;
    providerMatrix: number;
    channelManagers: ProviderSpotlightContactOutput[] | undefined;
    upcomingEvents: ProviderSpotlightEventOutput[] | undefined;
    providerSpotlightIds: number[] | undefined;
}

export enum ProviderSpotlightStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ProvidersAndUsersListDto implements IProvidersAndUsersListDto {
    id: number;
    name: string | undefined;
    provider: string | undefined;
    isActive: boolean;

    constructor(data?: IProvidersAndUsersListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.provider = _data['provider'];
            this.isActive = _data['isActive'];
        }
    }

    static fromJS(data: any): ProvidersAndUsersListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersAndUsersListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['provider'] = this.provider;
        data['isActive'] = this.isActive;
        return data;
    }

    clone(): ProvidersAndUsersListDto {
        const json = this.toJSON();
        let result = new ProvidersAndUsersListDto();
        result.init(json);
        return result;
    }
}

export interface IProvidersAndUsersListDto {
    id: number;
    name: string | undefined;
    provider: string | undefined;
    isActive: boolean;
}

export class SaleCodeDto implements ISaleCodeDto {
    id: number | undefined;
    name: string;
    isActive: boolean;
    providerId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: ISaleCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.isActive = _data['isActive'];
            this.providerId = _data['providerId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
        }
    }

    static fromJS(data: any): SaleCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['isActive'] = this.isActive;
        data['providerId'] = this.providerId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        return data;
    }

    clone(): SaleCodeDto {
        const json = this.toJSON();
        let result = new SaleCodeDto();
        result.init(json);
        return result;
    }
}

export interface ISaleCodeDto {
    id: number | undefined;
    name: string;
    isActive: boolean;
    providerId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}
